<style scoped="scoped" lang="scss"></style>
<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/document/permission/configuration/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('juesemingcheng')" required>
            <yi_data_select :type="'customerRole'" :ids.sync="yt.conditions.roleIds" multiple></yi_data_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_auth_user_create')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t("xinzeng") }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #rukudanjuleixing="scope">
        <template>
          <span v-for="(vo, index) in scope.row.inboundDocumentVOList"><span v-if="index != 0">,</span>{{ $t(vo.i18n) + "-" + vo.smallName }}</span>
        </template>
      </template>
      <template #chukudanjuleixing="scope">
        <template>
          <span v-for="(vo, index) in scope.row.outboundDocumentVOList"><span v-if="index != 0">,</span>{{ $t(vo.i18n) + "-" + vo.smallName }}</span>
        </template>
      </template>
      <template #kuneicaozuoleixing="scope">
        <template>
          <span v-for="(vo, index) in scope.row.insideDocumentVOList"><span v-if="index != 0">,</span>{{ $t(vo.i18n) + "-" + vo.smallName }}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_system_auth_user_update')" @click="yt.showEditDialog('bianji', scope.row)">{{ $t("bianji") }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/document/permission/configuration/delete')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('juesemingcheng')" required>
            <yi_data_select :type="'customerRole'" :ids.sync="yt.editObj.roleId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('rukudanjuleixing')">
            <el-cascader size="mini" :clearable="clearable" :props="{ multiple: true, value: 'value', label: 'label', emitPath: false, checkStrictly: false }" :show-all-levels="true" :collapse-tags="true" v-model="yt.editObj.inboundDocumentIds" :options="tree1"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('chukudanjuleixing')">
            <el-cascader size="mini" :clearable="clearable" :props="{ multiple: true, value: 'value', label: 'label', emitPath: false, checkStrictly: false }" :show-all-levels="true" :collapse-tags="true" v-model="yt.editObj.outboundDocumentIds" :options="tree2"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('kuneicaozuoleixing')">
            <el-cascader size="mini" :clearable="clearable" :props="{ multiple: true, value: 'value', label: 'label', emitPath: false, checkStrictly: false }" :show-all-levels="true" :collapse-tags="true" v-model="yt.editObj.insideDocumentIds" :options="tree3"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/document/permission/configuration/create')" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('juesemingcheng')" required>
            {{ yt.editObj.role.name }}
          </el-form-item>
          <el-form-item :label="$t('rukudanjuleixing')">
            <el-cascader size="mini" :clearable="clearable" :props="{ multiple: true, value: 'value', label: 'label', emitPath: false, checkStrictly: false }" :show-all-levels="true" :collapse-tags="true" v-model="yt.editObj.inboundDocumentIds" :options="tree1"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('chukudanjuleixing')">
            <el-cascader size="mini" :clearable="clearable" :props="{ multiple: true, value: 'value', label: 'label', emitPath: false, checkStrictly: false }" :show-all-levels="true" :collapse-tags="true" v-model="yt.editObj.outboundDocumentIds" :options="tree2"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('kuneicaozuoleixing')">
            <el-cascader size="mini" :clearable="clearable" :props="{ multiple: true, value: 'value', label: 'label', emitPath: false, checkStrictly: false }" :show-all-levels="true" :collapse-tags="true" v-model="yt.editObj.insideDocumentIds" :options="tree3"></el-cascader>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/document/permission/configuration/update')" type="primary">{{ $t("baocun") }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_system_document_permission_list",
  components: {},
  data() {
    return {
      tree1: [],
      tree2: [],
      tree3: [],
      columns: [
        {
          label: "juesemingcheng",
          prop: "role.name",
        },
        {
          label: "rukudanjuleixing",
          type: "slot",
        },
        {
          label: "chukudanjuleixing",
          type: "slot",
        },
        {
          label: "kuneicaozuoleixing",
          type: "slot",
        },
        {
          label: "chuangjianren",
          prop: "createByObject.nickname",
        },
        {
          label: "chuangjianshijian",
          type: "time",
          prop: "createTime",
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // this.yt.SELECT_URL = "/web/system/auth/user/listByIds";
      // this.yt.SELECT_RESULT_KEY = "data";
      // this.yt.SELECT_ID = "id";
      // this.yt.SELECT_TITLE = "nickname";
      this.yt.get(1);
      this.getRolesList();
      this.getTypeTree();
    }, 300);
  },
  filters: {
    getRoleText(value) {
      return value
        .map((item) => {
          return item.name;
        })
        .join(",");
    },
  },
  methods: {
    async getRolesList() {
      let response = await this.http.get("/web/customer/auth/role/page", {
        params: {
          pageNum: 1,
          pageSize: 10,
        },
      });
      this.rolesList = response.data.rows;
    },

    getTypeTree() {
      this.http
        .get("/web/document/type/configuration/listByType", {
          params: {
            type: 0,
          },
        })
        .then((res) => {
          this.tree1 = res.data;
        });

      this.http
        .get("/web/document/type/configuration/listByType", {
          params: {
            type: 1,
          },
        })
        .then((res) => {
          this.tree2 = res.data;
        });

      this.http
        .get("/web/document/type/configuration/listByType", {
          params: {
            type: 2,
          },
        })
        .then((res) => {
          this.tree3 = res.data;
        });
    },
  },
};
</script>
